import React from 'react';
import { Modal, Input, Form, Select, Icon, DatePicker, Tabs, Button, Spin, Radio } from 'antd';
import moment from 'moment';
import auth from '../../../common/utility/auth';
import './styles.css';
import { message } from 'antd';
import BarcodeReader from "react-barcode-reader";

import { VALE_INGRESO, VALE_SALIDA } from '../../../common/types/tipoComprobanteType';
import { INGRESO, SALIDA } from '../../../common/types/tipoMovimientoType';
import { REGISTRADO, ANULADO, IMPORTADO } from '../../../common/types/movimientoEstadoType';
import { FORMAT_NUMBER, FORMAT_3DECIMALS } from '../../../common/types/regularExpresionType';
import {
    VENTA_PRECIO_UNITARIO_INCLUYE_IGV,
    IMPUESTO_SELECTIVO_CONSUMO_VENTA,
    SERIE_POR_PRODUCTO
} from '../../../common/types/parametroType';

import DetalleProductoServicioModal from './FormModal/DetalleProductoServicioModal';
import DetalleReferenciaModal from './FormModal/DetalleReferenciaModal';
import TotalDetalle from './FormModal/TotalModal';

const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;



class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            result: "No result",
        };
        this.handleScan = this.handleScan.bind(this);

    }

    handleScan(data) {
        this.props.onScaner(
            data,
            this.props.form.setFieldsValue,
            this.props.form.getFieldValue,
            this.handleCalculateDetail
        );
    }

    handleError(err) {
        alert("error");
        console.error(err);
    }


    findDaysAndDates = (property, value) => {
        if (property === 'fechaStr') {
            debugger
            console.log('cambio 2');
            const fecha = moment(value, 'DD/MM/YYYY');
            const minFecha = fecha.format('YYYY/MM/DD');

            const gridProductos = this.props.form.getFieldValue('arrDetalle');
            const detalleProductos = this.props.formValues.listaComprobanteDetalle;
            for (var i = 0; i < detalleProductos.length; i++) {
                debugger
                var obj_current_data = gridProductos.filter(m => { return m.idProducto == detalleProductos[i].idProducto; })[0];

                detalleProductos[i].fechaVencimiento = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY');
                detalleProductos[i].flagAfecto = obj_current_data.flagAfecto;
                detalleProductos[i].precioUnitario = obj_current_data.precioUnitario;
                detalleProductos[i].cantidad = obj_current_data.cantidad;
                detalleProductos[i].subTotal = obj_current_data.subTotal;
                detalleProductos[i].igv = obj_current_data.igv;
                detalleProductos[i].total = obj_current_data.total;
                detalleProductos[i].lote = obj_current_data.lote;
                detalleProductos[i].minFechaStr = minFecha;
            }

            this.props.form.setFieldsValue({ listaComprobanteDetalle: detalleProductos });
        }
    }

    handleCompleteDecimals = (property, value) => {
        if (value === '' || isNaN(parseFloat(value).toFixed(3)))
            this.props.form.setFieldsValue({ [property]: '0.000' });
        else
            this.props.form.setFieldsValue({ [property]: parseFloat(value).toFixed(3) });
    }


    fetchNewValue = (value, numberDecimals) => {
        if (numberDecimals === 2)
            return value === '' || isNaN(parseFloat(value).toFixed(2)) ? 0 : parseFloat(value);
        if (numberDecimals === 3)
            return value === '' || isNaN(parseFloat(value).toFixed(3)) ? 0 : parseFloat(value);
        if (numberDecimals === 5)
            return value === '' || isNaN(parseFloat(value).toFixed(5)) ? 0 : parseFloat(value);

        return 0;
    };

    fetchFieldValue = (identifier, property) => {
        var result = parseFloat(this.props.form.getFieldValue(`${property}[${identifier}]`));
        return result;
    };

    fetchFieldValueSum = (identifier, property, paramValue) => {
        var suma = 0;
        var obj = Object.assign({}, this.props.form.getFieldValue(property));

        for (var [key, value] of Object.entries(obj)) {
            suma = suma + (key === identifier ? paramValue : parseFloat(value));
        }

        return suma;
    };

    handleRemoverProducto = (row) => {

        var detalleProductos = this.props.form.getFieldValue("detalleProductos");
        var detalleProductosFilter = detalleProductos.filter((m) => {
            return m.identifier !== row.identifier;
        });


        var sumaTotal = this.fetchFieldValueSum(row.identifier, "arrTotal", 0);
        var sumaSubTotal = this.fetchFieldValueSum(
            row.identifier,
            "arrSubTotal",
            0
        );
        var sumaIgv = sumaTotal - sumaSubTotal;
        var sumaTotalDetalle = sumaSubTotal;

        //Calculo de Totales 2 //

        this.props.form.setFieldsValue({
            sumaTotal: sumaTotal,
            sumaSubTotal: sumaSubTotal,
            sumaIgv: sumaIgv,
            sumaTotalDetalle: sumaTotalDetalle,
            detalleProductos: detalleProductosFilter
        });

        this.props.onRemoverProducto(row, this.props.form);
    };


    fetchSumaTotalAfecto = (
        identifier,
        codex,
        total
    ) => {
        let suma = 0;

        const arrTotal = this.props.form.getFieldValue("arrTotal");
        const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

        for (const [key, value] of Object.entries(arrTotal)) {

            // 👉 obtenemos el id del impuesto
            const impuestoKey = arrImpuesto?.[key]?.key;

            const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
                x => x.id === impuestoKey
            );

            const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

            // ✅ solo sumar si es 10 o 17
            var esGravado = ["10", "17"].includes(codigo);

            if (esGravado) {
                suma +=
                    identifier === key
                        ? Number(total.toFixed(2))
                        : parseFloat(value);
            }
        }

        return suma;
    };


    fetchSumaTotalInafecto = (
        identifier,
        codex,
        total
    ) => {
        let suma = 0;

        const arrTotal = this.props.form.getFieldValue("arrTotal");
        const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

        for (const [key, value] of Object.entries(arrTotal)) {

            // 👉 obtenemos el id del impuesto
            const impuestoKey = arrImpuesto?.[key]?.key;

            const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
                x => x.id === impuestoKey
            );

            const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

            // ✅ solo sumar si es 30
            const esInafecto = ["30"].includes(codigo);


            if (esInafecto) {
                suma +=
                    identifier === key
                        ? Number(total.toFixed(2))
                        : parseFloat(value);
            }
        }

        return suma;
    };


    fetchSumaTotalExonerado = (
        identifier,
        codex,
        total
    ) => {
        let suma = 0;

        const arrTotal = this.props.form.getFieldValue("arrTotal");
        const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

        for (const [key, value] of Object.entries(arrTotal)) {

            // 👉 obtenemos el id del impuesto
            const impuestoKey = arrImpuesto?.[key]?.key;

            const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
                x => x.id === impuestoKey
            );

            const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

            // ✅ solo sumar si es 20
            const esExonerado = ["20"].includes(codigo);

            if (esExonerado) {
                suma +=
                    identifier === key
                        ? Number(total.toFixed(2))
                        : parseFloat(value);
            }
        }

        return suma;
    };


    fetchSumaTotalGratuito = (
        identifier,
        codex,
        total
    ) => {
        let suma = 0;

        const arrTotal = this.props.form.getFieldValue("arrTotal");
        const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

        for (const [key, value] of Object.entries(arrTotal)) {

            // 👉 obtenemos el id del impuesto
            const impuestoKey = arrImpuesto?.[key]?.key;

            const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
                x => x.id === impuestoKey
            );

            const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

            // ✅ solo sumar si es 20
            const esGratuito = !["10", "20", "30", "40", "17"].includes(codigo);

            if (esGratuito) {
                suma +=
                    identifier === key
                        ? Number(total.toFixed(2))
                        : parseFloat(value);
            }
        }

        return suma;
    };

    handleCalculateDetail = (row, idProducto, property, value, numberDecimals) => {
        debugger;
        var newValue = this.fetchNewValue(value, numberDecimals);
        var params = auth.user().parametros;
        var identifier = row.identifier;
        // Datos de parametro //
        var porcentajeIGV = 18;
        var porcentajeISC = parseFloat(params.filter(m => m.abreviatura === IMPUESTO_SELECTIVO_CONSUMO_VENTA)[0].valor);
        var flagPrecioIncluyeIGV = params.filter(m => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV)[0].valor === "1" ? true : false;
        var flagVencimiento = row.flagVencimiento;



        var flagAfecto = false;
        var flagExonerado = false;
        var flagGratuito = false;
        var flagISC = false;

        var flagChangeTotal = false;

        var getImpuesto =
            property === "arridImpuesto"
                ? value
                : this.props.form.getFieldValue(`arridImpuesto[${row.identifier}]`).key;


        const selectedImpuesto = this.props.formValues.tipoAfectacion.find(x => x.id === getImpuesto);

        const DEFAULT_CODIGO = '10';
        const codigo = selectedImpuesto?.codigoSunat ?? DEFAULT_CODIGO;

        switch (true) {

            // Gravado
            case ["10", "17"].includes(codigo):
                flagAfecto = true;
                break;

            // Exonerado
            case codigo === "20":
                flagExonerado = true;
                break;

            // Inafecto
            case codigo === "30":
                break;

            // Exportación
            case codigo === "40":
                break;
        }




        //Datos por fila //
        var cantidad = property === "arrCantidad" ? newValue : this.fetchFieldValue(identifier, "arrCantidad");
        var precioUnitario = property === "arrPrecioUnitario" ? newValue : this.fetchFieldValue(identifier, "arrPrecioUnitario");
        var total = property === "arrTotal" ? newValue : this.fetchFieldValue(identifier, "arrTotal");
        var fechaVencimiento = property === "arrFechaVencimiento" ? value : this.props.form.getFieldValue(`arrFechaVencimiento[${identifier}]`);
        var lote = property === "arrLote" ? value : this.props.form.getFieldValue(`arrLote[${identifier}]`);

        var totalDetalle = cantidad * precioUnitario;


        /*********** Calculo precios unitarios ********/
        var divisorCalculoSubTotal = 1 + porcentajeIGV / 100;
        var precioUnitarioSinIGV = flagPrecioIncluyeIGV
            ? totalDetalle / divisorCalculoSubTotal
            : precioUnitario - (totalDetalle * 0.18);


        //Calculo totales //
        var subTotal = totalDetalle;
        var igv = parseFloat((flagAfecto ? subTotal * (porcentajeIGV / 100) : 0).toFixed(2));
        var total = parseFloat(((subTotal + igv)).toFixed(2));

        //var dateVcto = row.fechaVencimiento ? moment(row.fechaVencimiento).format('DD/MM/YYYY') : null;
        var dateVcto = row.flagVencimiento ? row.fechaVencimiento : null;

        //Arr Detalle //
        var detalle = {
            identifier,
            idProducto,
            flagAfecto,
            precioUnitario,
            cantidad,
            subTotal,
            igv,
            total,
            flagVencimiento: row.flagVencimiento,
            fechaVencimiento: dateVcto,
            flagAplicarSerie: row.flagAplicarSerie,
            detalleSeries: row.detalleSeries,
            listaDetalleSerie: row.listaDetalleSerie,
            idImpuesto: selectedImpuesto?.id ?? 1,
            lote
        };

        var detalleProductos = this.props.form.getFieldValue("detalleProductos");
        var detalleProductosFilter = detalleProductos.filter(m => { return m.identifier !== identifier });
        detalleProductosFilter.push(detalle);



        var sumaTotalAfecto = this.fetchSumaTotalAfecto(
            row.identifier,
            codigo,
            total
        );
        var sumaTotalInafecto = this.fetchSumaTotalInafecto(
            row.identifier,
            codigo,
            total
        );

        var fetchSumaTotalExonerado = this.fetchSumaTotalExonerado(
            row.identifier,
            codigo,
            total
        );

        var fetchSumaTotalGratuito = this.fetchSumaTotalGratuito(
            row.identifier,
            codigo,
            total
        );

        // Calculo suma detalle //
        var sumaTotal = parseFloat(this.fetchFieldValueSum(row.identifier, "arrTotal", total).toFixed(2));
        var sumaSubTotal = parseFloat(
            (
                sumaTotalAfecto / divisorCalculoSubTotal +
                (sumaTotalInafecto + fetchSumaTotalExonerado)
            ).toFixed(2)
        );

        var sumaIgv = (sumaTotal - fetchSumaTotalGratuito) - sumaSubTotal;
        var sumaTotalDetalle = sumaSubTotal;

        this.props.form.setFieldsValue({
            sumaTotal: sumaTotal,
            sumaSubTotal: sumaSubTotal,
            sumaIgv: sumaIgv,
            detalleProductos: detalleProductosFilter,
            [`arrFlagAfecto[${identifier}]`]: flagAfecto,
            //[`arrFechaVencimiento[${identifier}]`]: fechaVencimiento,
            [`arrLote[${identifier}]`]: lote,
            [`arrPrecioUnitario[${identifier}]`]: precioUnitario.toFixed(5),
            [`arrCantidad[${identifier}]`]: cantidad.toFixed(3),
            [`arrSubTotal[${identifier}]`]: subTotal.toFixed(2),
            [`arrIgv[${identifier}]`]: igv.toFixed(2),
            [`arrTotal[${identifier}]`]: total.toFixed(2)
        });

        this.props.form.setFieldsValue({
            detalleProductos: detalleProductosFilter
        });
    };

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    };

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);

            if (values.detalleProductos.filter(m => { return m.flagAplicarSerie === true; }).length > 0) {
                values.detalleProductos.forEach(row => {
                    if (row.listaDetalleSerie.length === 0 && row.flagAplicarSerie) {
                        message.warning("Por favor agregue las series para el producto " + row.nombre);
                        return false;
                    }
                });
            }

            if (!err) {
                var params = auth.user().parametros;
                var porcentajeIGV = 18;

                const form = {
                    "id": values.id,
                    "idTipoMovimiento": SALIDA.ID,
                    "idEntidad": values.idEntidad,
                    "idConcepto": values.idConcepto.key,
                    "idAlmacen": values.idAlmacen.key,
                    "idMoneda": values.idMoneda.key,
                    "orden": 1,
                    "idTipoAlmacen": values.idTipoAlmacen.key,
                    "idTipoComprobante": VALE_SALIDA.ID,
                    "serie": "S001",
                    "documento": null,
                    "fecha": null,
                    "fechaStr": values.fechaStr.format('DD/MM/YYYY'),
                    "tipoCambio": parseFloat(values.tipoCambio),
                    "porcentajeIGV": porcentajeIGV,
                    "subTotal": values.sumaSubTotal,
                    "igv": values.sumaIgv,
                    "total": values.sumaTotal,
                    "peso": null,
                    "observacion": values.observacion,
                    "fechaActivacion": null,
                    "idMovimientoEstado": REGISTRADO,
                    "movimientoDetalles": [],
                    "movimientoReferencias": [],
                    "idOrdenCompra": values.idOrdenCompra,
                    "idProyecto": values.idProyecto === undefined ? 0 : values.idProyecto.key,
                    "movimientoReferencias": this.fetchReferencias(values),
                    "claim": values.claim == undefined ? '' : values.claim,
                }


                var conceptos = values.concepto;
                conceptos = conceptos.filter(e => e.id == values.idConcepto.key)

                if (form.movimientoReferencias.length <= 0 && ["01", "06", "11"].includes(conceptos[0].codigoSunat)) {
                    message.warning('Debe de ingresar como mínimo 1 referencia.');
                    return;
                }


                if (values.detalleProductos.length <= 0) {
                    message.warning('Debe de ingresar como mínimo 1 producto.');
                    return;
                }

                if (values.detalleProductos.length <= 0) {
                    message.warning('Debe de ingresar como mínimo 1 producto.');
                    return;
                }

                //Detalles----->
                var count_detalles = values.detalleProductos.length;
                for (var i = 0; i < count_detalles; i++) {
                    var det = values.detalleProductos[i];
                    let valorUnitario = parseFloat(this.fetchFieldValue(det.identifier, "arrPrecioUnitario"));
                    const itemDet = {
                        "id": 0,
                        "idMovimiento": 0,
                        "idProducto": parseInt(det.idProducto),
                        "nombre": det.nombre,
                        "flagAfecto": det.flagAfecto,
                        "cantidad": det.cantidad,
                        "valorUnitario": parseFloat(this.fetchFieldValue(det.identifier, "arrPrecioUnitario")),
                        "precioUnitario": (parseFloat(valorUnitario) * 1.18),
                        "subTotal": det.subTotal,
                        "igv": det.igv,
                        "total": det.total,
                        "fecha": null,
                        "ListaMovimientoDetalleSerie": det.listaDetalleSerie,
                        "flagVencimiento": det.flagVencimiento,
                        "fechaVencimientoStr": det.fechaVencimiento,
                        "fechaStr": null,
                        "numeroLote": det.lote,
                        "item": null,
                        "precioPromedio": null,
                        "subtotalPromedio": null,
                        "totalPromedio": null,
                        "precioUnitarioPrueba": null,
                        "operacion": null,
                        "idImpuesto": det.idImpuesto,
                        "identifier": det.identifier
                    }

                    form.movimientoDetalles.push(itemDet);
                }

                this.props.onSave(form, this.props.form);
            }
        });
    }

    fetchReferencias = (values) => {

        var result = [];
        var keys = [];
        var obj = Object.assign({}, values.arrIdTipoComprobante);

        for (var [key] of Object.entries(obj)) {
            keys.push(key);
        }
        keys.forEach((key) => {
            result.push({
                idTipoComprobante: values.arrIdTipoComprobante[key].key,
                serie: values.arrSeries[key],
                documento: values.arrDocumentos[key],
                idReferencia: values.arrIdReferencia[key],
                idReferenciaOrigen: values.arrIdReferenciaOrigen[key],
                flagInterno: values.arrFlagInterno[key],
            });
        });

        return result;
    };

    handleChangeNameProduct = (row) => {
        console.log(row);
        this.props.onChangeNameProduct(row);
    }

    render() {
        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;
        const seriePorProducto = auth.user().parametros.filter(m => m.abreviatura === SERIE_POR_PRODUCTO)[0].valor === "1" ? true : false;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('detalleProductos', { initialValue: this.props.formValues.detalleProductos });

        getFieldDecorator('sumaSubTotal', { initialValue: this.props.formValues.sumaSubTotal });
        getFieldDecorator('sumaIgv', { initialValue: this.props.formValues.sumaIgv });
        getFieldDecorator('sumaTotal', { initialValue: this.props.formValues.sumaTotal });
        getFieldDecorator('concepto', { initialValue: this.props.formValues.conceptos });

        return (
            <Modal
                title="Registro de Salida"
                visible={this.props.visible}
                style={{ top: 30 }}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                width="1200px"
            >
                <BarcodeReader onError={this.handleError} onScan={this.handleScan} />

                <Form>
                    {getFieldDecorator('id', { initialValue: this.props.formValues.id })(
                        <input type="hidden" />
                    )}

                    {getFieldDecorator('idOrdenCompra', { initialValue: this.props.formValues.idOrdenCompra })(
                        <input type="hidden" />
                    )}

                    <div className="row">
                        <div className="col-md-4 form-group">
                            <Form.Item label="Fecha / Tipo de Cambio">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '65%' }}>
                                        {getFieldDecorator('fechaStr', {
                                            initialValue: moment(this.props.formValues.fechaStr, 'DD/MM/YYYY'),
                                            rules: [{
                                                type: 'object',
                                                required: true,
                                                message: 'Requerido'
                                            }],
                                        })(
                                            <DatePicker
                                                disabled={!this.props.formValues.flagClaim}
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                format="DD/MM/YYYY"
                                                onChange={(moment, value) => {
                                                    this.props.onChange('fechaStr', value);
                                                    this.findDaysAndDates('fechaStr', value);
                                                }}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '35%' }}>
                                        {getFieldDecorator('tipoCambio', {
                                            initialValue: parseFloat(this.props.formValues.tipoCambio).toFixed(3),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_3DECIMALS),
                                                message: "Formato decimal incorrecto (0.000)"
                                            }]
                                        })(
                                            <Input
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                                onBlur={(e) => this.handleCompleteDecimals("tipoCambio", e.target.value)}
                                            />
                                        )}
                                    </Form.Item>

                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Serie / Documento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '40%' }}>
                                        {getFieldDecorator('serie', {
                                            initialValue: this.props.formValues.serie
                                        })(
                                            <Input
                                                placeholder="Serie"
                                                autoComplete="off"
                                                className="first-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '60%' }}>
                                        {getFieldDecorator('documento', {
                                            initialValue: this.props.formValues.documento
                                        })(
                                            <Input
                                                placeholder="Documento"
                                                autoComplete="off"
                                                className="second-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Moneda">
                                {getFieldDecorator('idMoneda', {
                                    initialValue: this.props.formValues.idMoneda ?
                                        { key: this.props.formValues.idMoneda } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Moneda"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.onChange('idMoneda', option.key, this.props.form)}
                                    >
                                        {this.props.formValues.monedas.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-8 form-group">
                            <Form.Item label="Entidad">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '100%' }}>
                                        {getFieldDecorator('idEntidad', {
                                            initialValue: this.props.formValues.idEntidad || undefined,
                                            rules: [{
                                                required: true,
                                                message: 'Campo obligatorio.',
                                            }]
                                        })(
                                            <Select
                                                showSearch
                                                placeholder="Seleccione Entidad"
                                                optionFilterProp="children"
                                                className="second-input"
                                                notFoundContent={this.props.fetching ? <Spin size="small" /> : null}
                                                filterOption={false}

                                                onSearch={this.props.fetchClientes}
                                                onSelect={(value, option) => {
                                                    this.props.onChangeEntidad(value, this.props.form)
                                                }}
                                            >
                                                {this.props.formValues.entidades.map(item => (
                                                    <Option key={item.id} value={item.id}>
                                                        {item.razonSocial + ' - ' + item.tipoDocumento + ' - ' + item.numeroDocumento}
                                                    </Option>
                                                ))}
                                            </Select>
                                        )}
                                    </Form.Item>

                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Concepto">
                                {getFieldDecorator('idConcepto', {
                                    initialValue: this.props.formValues.idConcepto ?
                                        { key: this.props.formValues.idConcepto } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Concepto"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.onChange("idConcepto", option.key, this.props.form)
                                        }}
                                    >
                                        {this.props.formValues.conceptos.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>


                    </div>

                    <div className="row">
                        <div className="col-md-4 form-group">
                            <Form.Item label="Establecimiento">
                                {getFieldDecorator('idEstablecimiento', {
                                    initialValue: this.props.formValues.idEstablecimiento ?
                                        { key: this.props.formValues.idEstablecimiento } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Establecimiento"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.onChange("idEstablecimiento", option.key, this.props.form)
                                        }}
                                    >
                                        {this.props.formValues.establecimientos.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>


                        <div className="col-md-4 form-group">
                            <Form.Item label="Tipo Almacén">
                                {getFieldDecorator('idTipoAlmacen', {
                                    initialValue: this.props.formValues.idTipoAlmacen ?
                                        { key: this.props.formValues.idTipoAlmacen } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Almacén"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({ idAlmacen: undefined });
                                            this.props.onChange("idTipoAlmacen", option.key, this.props.form)
                                        }}                                    >
                                        {this.props.formValues.TipoAlmacen.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-4 form-group">
                            <Form.Item label="Almacén">
                                {getFieldDecorator('idAlmacen', {
                                    initialValue: this.props.formValues.idAlmacen ?
                                        { key: this.props.formValues.idAlmacen } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Almacén"}
                                        optionFilterProp="children"
                                        loading={this.props.formValues.almacenLoading}
                                        onChange={(option) => {
                                            this.props.onChange("idAlmacen", option.key, this.props.form)
                                        }}
                                    >
                                        {this.props.formValues.almacenes.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>


                    </div>

                    <div className="row">
                        <div className={this.props.formValues.flagClaim ? 'col-md-6 form-group' : 'col-md-8 form-group'}>
                            <Form.Item label="Observación">
                                {getFieldDecorator('observacion', {
                                    initialValue: this.props.formValues.observacion
                                })(
                                    <Input
                                        placeholder="Ingresar Observación"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-2 form-group" hidden={!this.props.formValues.flagClaim}>
                            <Form.Item label="Claim">
                                {getFieldDecorator('claim', {
                                    initialValue: this.props.formValues.claim
                                })(
                                    <Input
                                        placeholder="Ingresar Claim"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Proyecto">
                                {getFieldDecorator('idProyecto', {
                                    initialValue: this.props.formValues.idProyecto ?
                                        { key: this.props.formValues.idProyecto } : 0
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Proyecto"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.onChange('idProyecto', option.key, this.props.form)}
                                    >
                                        <Option key={0} value={0}>
                                            <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                                        </Option>
                                        {this.props.formValues.proyectos.map(item => (
                                            item.estado ?
                                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                                : null
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs
                                activeKey={this.props.formValues.activeKey}
                                onChange={this.props.onChangeTab}
                                tabBarExtraContent={
                                    <Button
                                        icon="plus"
                                        type="primary"
                                        onClick={() => this.props.onAgregarDetalle(this.props.form.setFieldsValue, this.props.form.getFieldValue)}
                                    >
                                        Agregar
                                    </Button>
                                }
                            >
                                <TabPane tab="Detalle de Productos y Servicios" key="1">
                                    {seriePorProducto == 1 ?
                                        <div className="col-md-12 form-group" style={{ marginLeft: -20 }}>
                                            <div className="col-md-12 form-group">
                                                <Form.Item>
                                                    {getFieldDecorator('flagTipoBusquedaScanner', {
                                                        initialValue: this.props.formValues.flagTipoBusquedaScanner
                                                    })(
                                                        <Radio.Group name="radiogroup"
                                                        // onChange={(e) => this.props.onChangeForm("flagTipoBusquedaScanner", e.target.value, this.props.form)}
                                                        >
                                                            <Radio value={0}>Búsqueda por código de barra</Radio>
                                                            <Radio value={1}>Búsqueda por serie</Radio>
                                                        </Radio.Group>
                                                    )}
                                                </Form.Item>
                                            </div>
                                        </div> : null
                                    }

                                    <DetalleProductoServicioModal
                                        dataSource={this.props.formValues.listaComprobanteDetalle}
                                        onAgregarSerie={this.props.onAgregarSerie}
                                        onRemove={this.handleRemoverProducto}
                                        onCalculateDetail={this.handleCalculateDetail}
                                        onGetFieldDecorator={getFieldDecorator}
                                        onGetFieldValue={getFieldValue}
                                        onSetFieldsValue={setFieldsValue}
                                        onChangeNameProduct={this.handleChangeNameProduct}
                                        tipoAfectacion={this.props.formValues.tipoAfectacion}

                                    />
                                </TabPane>
                                <TabPane tab="Detalle de Referencias" key="2">
                                    <DetalleReferenciaModal
                                        dataSource={this.props.formValues.listaComprobanteReferencia}
                                        tiposComprobante={this.props.formValues.tiposComprobante}
                                        onRemove={this.props.onRemoverReferencia}
                                        onGetFieldDecorator={getFieldDecorator}
                                    />
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                    <TotalDetalle
                        formValues={this.props.formValues}
                        onGetFieldDecorator={getFieldDecorator}
                        onGetFieldValue={getFieldValue}
                    />

                </Form>
            </Modal>
        )
    }
}
export default Form.create()(FormModal)